import { TiltedGridHero } from "@/components/ui/tilted-grid-hero"
import { cn } from "@/lib/utils"

// Step images used in HowItWorks
import freeQuotation from "/free-quotation.png"
import transparentPricing from "/sup-quote.png"
import supplierReach from "/sup-reach.png"
import simpleWorkflow from "/flow.png"
import globalSupport from "/global-support.png"

const STEP_IMAGES = [
  {
    src: freeQuotation,
    number: "01",
    title: "Free Quotation",
    description: "Fast, custom factory quotes tailored to your exact specs.",
    alt: "01 - Free Quotation",
  },
  {
    src: transparentPricing,
    number: "02",
    title: "Transparent Pricing",
    description: "Clear, itemized cost breakdowns with zero hidden fees.",
    alt: "02 - Transparent Pricing",
  },
  {
    src: supplierReach,
    number: "03",
    title: "Supplier Reach",
    description: "Direct access to verified factories across global hubs.",
    alt: "03 - Supplier Reach",
  },
  {
    src: simpleWorkflow,
    number: "04",
    title: "Simple Workflow",
    description: "Track orders, milestones, and approvals in one dashboard.",
    alt: "04 - Simple Workflow",
  },
  {
    src: globalSupport,
    number: "05",
    title: "Global Support",
    description: "24/7 multilingual assistance from dedicated sourcing managers.",
    alt: "05 - Global Support",
  },
]

export function HowItWorksTiltedGrid({ className }: { className?: string } = {}) {
  return (
    <section
      id="how-it-works"
      className={cn(
        "relative w-full pb-6 md:pb-8 bg-white text-gray-900 select-none overflow-hidden scroll-mt-12 md:scroll-mt-14",
        className
      )}
      aria-label="How it works cylindrical flow layout"
    >
      {/* ── Section Header (Identical to HowItWorks for direct comparison) ── */}
      <div className="text-center mb-0 px-4 max-w-4xl mx-auto">
        <h2 className="text-2xl font-sans sm:text-3xl md:text-[34px] lg:text-[40px] font-bold text-slate-950 tracking-tight leading-tight">
          <span>From Sourcing to Delivery, </span>
          <br className="hidden sm:inline" />
          <span className="text-primary font-bold">We Handle Everything.</span>
        </h2>
      </div>

      {/* ── Full-Width Tilted Cylindrical Stream Hero (Starts & Ends with Homepage Sides) ── */}
      <TiltedGridHero
        images={STEP_IMAGES}
        speed={4.5}
        curve={65}
        tileHeight={48}
        aspectRatio={4 / 3}
        axis={46}
        gap={2}
        fade={12}
        className="-mt-3 sm:-mt-5 h-[360px] sm:h-[400px] md:h-[450px] w-full bg-transparent"
      />
    </section>
  )
}

export default HowItWorksTiltedGrid
